import { useMemo } from "react";
import { Typography } from "../components/atoms/Typography";
import { LibraryGrid } from "../components/organisms/LibraryGrid";
import { libraryTiles } from "../data/library";
import { useAuthSession } from "../contexts/AuthSessionContext";
import {
  canAccessContractsLibraryAdmin,
  canAccessPrizeRulesLibraryAdmin,
  canAccessRfpLibraryAdmin,
} from "../utils/sessionModuleAccess";

export const LibraryPage = () => {
  const { adminRoles } = useAuthSession();

  const tiles = useMemo(() => {
    return libraryTiles.filter((tile) => {
      if (tile.requiredCapability === "contracts") {
        return canAccessContractsLibraryAdmin(adminRoles);
      }
      if (tile.requiredCapability === "rfp") {
        return canAccessRfpLibraryAdmin(adminRoles);
      }
      if (tile.requiredCapability === "prize_rules") {
        return canAccessPrizeRulesLibraryAdmin(adminRoles);
      }
      return false;
    });
  }, [adminRoles]);

  return (
    <section className="page-section max-w-7xl mx-auto">
      <header className="page-header">
        <div>
          <Typography as="h1" variant="h1">
            Library
          </Typography>
          <p className="page-subtitle">
            Access your organization&apos;s document templates and resources.
          </p>
        </div>
      </header>
      <LibraryGrid tiles={tiles} />
    </section>
  );
};
